import { cleanSourceFields, getArray } from '../../utils.js';

var dataSource = (_ref => {
  let {
    data_source_algorithm,
    data_source_algorithm_version,
    data_source_name = ''
  } = _ref;
  return () => ({
    data_source_algorithm: cleanSourceFields(getArray(data_source_algorithm)),
    data_source_algorithm_version: cleanSourceFields(getArray(data_source_algorithm_version)),
    data_source_name: decodeURIComponent(data_source_name)
  });
});

export default dataSource;
